const SET_INVERTER = 'SET_INVERTER'
const UNSET_INVERTER = 'UNSET_INVERTER'

export default {
  namespaced: true,
  state: {
    inverter: null
  },
  getters: {
    inverter (state) {
      return state.inverter
    }
  },
  mutations: {
    [SET_INVERTER] (state, inverter) {
      state.inverter = inverter
    },
    [UNSET_INVERTER] (state) {
      state.inverter = null
    }
  },
  actions: {
  }
}
